// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Containers
import withFormField from '../../containers/with-form-field';

// Styles
import './input.scss';

class Checkbox extends Component {
    getClass() {
        const {className} = this.props;

        return classnames(
            {
                input: true,
            },
            className
        );
    }

    handleChange = (event) => {
        const {defaultValue, uncheckedValue = '', onChange} = this.props;

        onChange(event, event.target.checked ? defaultValue : uncheckedValue);
    };

    handleKeyPress = (event) => {
        event.stopPropagation();
    };

    render() {
        const {checked, defaultValue, disabled, id, name, onBlur, onClick, type, value} = this.props;
        const props = {
            checked: checked || String(value) === defaultValue,
            className: this.getClass(),
            disabled,
            id,
            name,
            onBlur,
            onChange: this.handleChange,
            onClick,
            onKeyPress: this.handleKeyPress,
            type,
            value,
        };

        return <input {...props} />;
    }
}

Checkbox.propTypes = {
    checked: PropTypes.bool,
    className: PropTypes.string,
    defaultValue: PropTypes.string,
    disableAutofill: PropTypes.bool,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    size: PropTypes.number,
    type: PropTypes.string.isRequired,
    uncheckedValue: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]).isRequired,
};

export default withFormField(Checkbox, 'checkbox');
